import APIBuilder from '@quangphuc/frontend-api-builder';
import Entity from '@/entities/entity';
import { singleton } from '@/helper/design-pattern';

export interface ServiceInterface<T extends Entity> {
  apiBuilder: APIBuilder<T>;
}

export interface CRUDServiceInterface<T extends Entity>
  extends ServiceInterface<T> {
  getOne(id: number): Promise<T>;
  createOne(instance: Partial<T>): Promise<T>;
  updateOne(id: number, instance: Partial<T>): Promise<T>;
}

export function CreateService<T extends Entity>(store: string) {
  return class implements ServiceInterface<T> {
    store: string = store;
    apiBuilder: APIBuilder<T> = APIBuilder.store<T>(store);

    async createOne(instance: Partial<T>): Promise<T> {
      const { data } = await this.apiBuilder.createOne(instance);
      return data;
    }

    async getOne(id: number, join: string[] = []): Promise<T> {
      const { data } = await this.apiBuilder.join(join).getOne(id);
      return data;
    }

    async updateOne(id: number, instance: Partial<T>): Promise<T> {
      const { data } = await this.apiBuilder.updateOne(id, instance);
      return data;
    }

    async deleteOne(id: number): Promise<T> {
      const { data } = await this.apiBuilder.deleteOne(id);
      return data;
    }
  };
}

export function UseService(Service: any): PropertyDecorator {
  return function Decorator(target: any, propertyKey) {
    target[propertyKey] = singleton(Service);
  };
}

export const service = singleton;
